import { TireSelector } from '../tireselector-v2/tireselector';
import type { TireSize } from '../tireselector-v2/tireselector';

export class QuickbuyTireSelector extends TireSelector {
  constructor(element:HTMLElement) {
    super(element, 'QBTS');
  }

  /**
   * Override parent method.
   * Quick buy tire selector does not redirect on size select.
   */
  doActionOnSizeSelect(sizeObj: TireSize) {
    // Do nothing
  }
}
